import { Link } from '@tanstack/react-router';
import { useAdminAreas } from '../hooks';
import { ADMIN_SCROLLBAR_CLASSES } from '../constants';

export const AreasList = () => {
  const { data: areas, isError } = useAdminAreas();

  return (
    <div className="px-4 py-6 max-w-4xl space-y-4">
      {/* Header */}
      <div>
        <h1 className="text-xl font-bold text-[#E8E8E8] capitalize">Areas</h1>
        {areas && (
          <p className="text-sm text-[#999] mt-1">
            {areas.length} {areas.length === 1 ? 'area' : 'areas'}
          </p>
        )}
      </div>

      {/* Body */}
      {isError && (
        <div className="text-sm text-red-400">Failed to load areas.</div>
      )}

      {!isError && areas && areas.length === 0 && (
        <div className="text-sm text-[#999]">No areas available.</div>
      )}

      {areas && areas.length > 0 && (
        <div className={`overflow-y-auto max-h-[calc(100vh-200px)] ${ADMIN_SCROLLBAR_CLASSES}`}>
          {/* Column headers */}
          <div className="grid grid-cols-[1fr_64px] gap-4 px-4 pb-2">
            <span className="text-xs font-semibold text-[#999] uppercase tracking-wide">Name</span>
            <span />
          </div>

          {/* Rows */}
          {areas.map((area) => (
            <div
              key={area.slug}
              className="grid grid-cols-[1fr_64px] gap-4 px-4 py-3 rounded hover:bg-[#303030] transition-colors items-center"
            >
              <div className="min-w-0">
                <span className="text-sm font-medium text-[#E8E8E8] truncate block">{area.title}</span>
                <span className="text-xs text-[#999] truncate block mt-0.5 capitalize">{area.subjectName.plural}</span>
              </div>
              <Link
                to="/admin/areas/$areaSlug"
                params={{ areaSlug: area.slug }}
                className="text-xs text-[#C3D82E] hover:underline text-right"
              >
                {area.accessType === 'ADMIN' ? 'Manage' : 'View'} →
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
